var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { MembreService } from 'membre/store/service';
import { MembreAdmin } from './MembreAdmin.class';
import { MembrePrive } from './MembrePrive.class';
import { MembrePublic } from './MembrePublic.class';
import { AdminService } from 'admin/store/service';
import { useFormatDate } from 'common/hooks/useFormatDate.hook';
/**
 * Les attributs de cet objet sont visibles par tout les utilisateurs
 */
export class Membre {
    /**
     * Constructeur de l'objet Membre
     * @param row array contenant les données de l'objet
     */
    constructor(rowPublic, rowPrive, rowAdmin) {
        if (rowPublic) {
            this.infoPublic = new MembrePublic(rowPublic);
            this.infoPrive = rowPrive ? new MembrePrive(rowPrive) : null;
            this.infoAdmin = rowAdmin ? new MembreAdmin(rowAdmin) : null;
        }
    }
    /**
     * Utilisée pour renvoyer les informations au back.
     */
    toRaw() {
        return {
            infoPublic: this.infoPublic ? this.infoPublic.toRaw() : null,
            infoPrive: this.infoPrive ? this.infoPrive.toRaw() : null,
            infoAdmin: this.infoAdmin ? this.infoAdmin.toRaw() : null,
        };
    }
    /**
     * Détermine si le membre est en ligne
     * @return true si membre en ligne
     */
    isOnline() {
        if (this.infoPublic) {
            return Membre.ONLINE_DELAY >= Math.round(Date.now() / 1000 - this.infoPublic.derniereConnexion);
        }
        return false;
    }
    /**
     * Récupère le statut du membre
     * @return String indiquant si le membre est en ligne ou la date de sa dernière connexion
     */
    getStatus() {
        var _a;
        return this.isOnline()
            ? 'En ligne'
            : `Dernière connexion ${useFormatDate({
                date: (_a = this.infoPublic) === null || _a === void 0 ? void 0 : _a.derniereConnexion,
                display: 'relative',
            })}`;
    }
    /**
     * Sauvegarde un membre en base de données
     */
    save() {
        return __awaiter(this, void 0, void 0, function* () {
            return MembreService.saveMember(this);
        });
    }
    /**
     * Supprime le membre
     * @param idRaison Identifiant de la raison de la suppression
     * @param commentaire *(optionnel)* Commentaire de la suppression
     * @return True si l'opération a réussie
     */
    delete(idRaison, commentaire) {
        return __awaiter(this, void 0, void 0, function* () {
            return AdminService.deleteMember(this.infoPublic.idMembre, idRaison, commentaire);
        });
    }
    /**
     * Envoi un mail de récupération de mot de passe à l'utilisateur.
     * @param mail mail de l'utilisateur ayant perdu son mot de passe
     * @return true si action réussie
     */
    static sendMailForgotPassword(mail) {
        return __awaiter(this, void 0, void 0, function* () {
            return MembreService.sendMailForgotPassword(mail);
        });
    }
    /**
     * Change le mot de passe d'un utilisateur qui a perdu son mot de passe
     * @param motDePasse nouveau mot de passe de l'utilisateur
     * @return true si action réussie, false sinon
     */
    changeForgotPassword(motDePasse) {
        return __awaiter(this, void 0, void 0, function* () {
            return MembreService.changeForgotPassword(this.infoPublic.idMembre, motDePasse);
        });
    }
    /**
     * Remplace le système du HTACCESS et HTPASSWD
     * @param identifiant Identifiant du HTPASSWD
     * @param motDePasse Mot de passe du HTPASSWD
     * @return true si utilisateur connecté, false sinon
     */
    static checkHTAccess(identifiant, motDePasse) {
        return __awaiter(this, void 0, void 0, function* () {
            return MembreService.checkHTAccess(identifiant, motDePasse);
        });
    }
}
/**
 * Temps pour que le membre soit en ligne
 */
Membre.ONLINE_DELAY = 15 * 60;
//# sourceMappingURL=data:application/json;base64,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